import { render, staticRenderFns } from "./user.vue?vue&type=template&id=05a7fbd7&scoped=true&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"
import style0 from "./user.vue?vue&type=style&index=0&id=05a7fbd7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a7fbd7",
  null
  
)

export default component.exports